




































































































































































import { Component, Vue, Prop } from "vue-property-decorator";

import EventBus from "@/utils/helpers/EventBus";

export type TableToolbarButton = {
  action: string;
  color: string;
  height: string;
};

@Component
export default class TableToolbar extends Vue {
  /**
   * An array of buttons, has a default value (add, edit, delete, import, download)
   */
  @Prop({
    default: () => [
      {
        action: "add",
        color: "#88c23f"
      },
      {
        action: "edit",
        color: "#f3e80f"
      },
      {
        action: "delete",
        color: "#e90c6e"
      },
      {
        action: "import",
        color: "#00AAEB"
      },
      {
        action: "download",
        color: "#90298e"
      }
    ],
    type: Array
  })
  private buttons!: TableToolbarButton[];

  /**
   * Exact prop to specify whether an import button is enabled
   */
  @Prop({ default: false, type: Boolean })
  private showImport!: boolean;

  private focused = false;

  private onButtonClick(action: string) {
    /**
     * Toolbar action event, emits on button click
     * @event table-toolbar-action
     */

    EventBus.$emit(`table-toolbar-${action}`);
  }

  private get computedButtons() {
    return this.buttons.filter(item => {
      const allowImport =
        this.showImport || this.$isAppFeatureEnabled("TABLE_IMPORT");
      const allowDownload = this.$isAppFeatureEnabled("TABLE_DOWNLOAD");

      if (item.action === "import") {
        return allowImport;
      } else if (item.action === "download") {
        return allowDownload;
      } else {
        return true;
      }
    });
  }
}
